import { useContext } from "react";
import { AppContext, AppContextInterface } from "../../state/ContextProvider";

const Registration = () => {
  const app = useContext(AppContext) as AppContextInterface;

  const {
    state: { registration },
  } = app;

  return (
    <div className="vehicle-registration">
      <p className="reg-number">{registration}</p>
    </div>
  )
}

export { Registration }
